import React from "react";
import { Link } from "react-router-dom";

const Footer = ({ metalType = "Gold" }) => {
  return (
    <div className="col-md-12" style={{ marginBottom: "1rem" }}>
      <p className="text-center mt-2 footer_p">
        {/* Bajaj Capital Pvt Ltd (BCPL)  */}
        {metalType} bought in last 7 days can not be sold.{" "}
        {/* BCPL offers{" "}{metalType} products through our partners. */}
        {/* Refer to{" "}
        <Link
          target="_blank"
          to="https://www.bajajcapital.com/term-conditions?doc=tnc"
          className="underline-link"
        >
          Terms & Conditions
        </Link>{" "}
        of {metalType} for details. */}
      </p>
    </div>
  );
};

export default Footer;
